function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Text, View } from "../../../native";
import Icon from "../../../Icon";
import * as R from 'unitx/ramda';
import { useFormContext } from "../FormContext";

const TitleField = ({
  title,
  required,
  formContext,
  titleOptions = {},
  icons
}) => {
  const {
    mapping,
    titleEnabled,
    requiredTitle
  } = useFormContext(formContext); // const isAnyOrObjectType = React.useMemo(() => isAnyOfOrObjectType(schema), [schema])

  return titleEnabled ? /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style, {
      flexDirection: 'row'
    }]
  }), /*#__PURE__*/React.createElement(Text, _extends({}, mapping.title, {
    style: [mapping.title.style]
  }, titleOptions), title), required && /*#__PURE__*/React.createElement(Text, _extends({}, mapping.errorText, {
    style: {
      textAlignVertical: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center'
    }
  }), `  ${requiredTitle}`), icons && /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'absolute',
      flexDirection: 'row',
      right: 30,
      top: -3
    }
  }, R.mapIndexed((icon, index) => icon && /*#__PURE__*/React.createElement(Icon, _extends({
    key: index // @ts-ignore

  }, icon)))(icons)), /*#__PURE__*/React.createElement(View, {
    style: {
      width: '100%',
      height: 1,
      marginTop: 2,
      position: 'absolute',
      bottom: -1
    }
  })) : null;
};

export default TitleField;